// extracted by mini-css-extract-plugin
export default {"modal":"ErrorModal_modal__EboCM","overlay":"ErrorModal_overlay__8Awx0","wrapper":"ErrorModal_wrapper__Mctpn","stop":"ErrorModal_stop__OKlD2","close":"ErrorModal_close__luaDv"};